import { useForm } from "react-hook-form";
import InputComponent from "../../components/input/input.component";
import Modal from "../../components/modal/modal.component";
import SelectComponent from "../../components/select/select.component";
import { useEffect, useState } from "react";
import { CustomersService } from "../../services/customers";
import Button from "../../components/button/button.component";
import { UtilsService } from "../../services/utils";

function CustomerForm({ show, setShow, data, onChange }: any) {
  const [customers, setCustomers] = useState<any[]>([]);
  const [fields, setFields] = useState<any[]>([]);

  const defaultValues = {
    index         : -1,
    customer      : '',
    customer_name : '',
    field         : '',
    field_name    : '',
    cajas         : '',
    peso_caja     : '',
    kg_totales    : '',
  };

  const {
    watch,
    setValue,
    getValues,
    reset,
    register,
    handleSubmit,
    formState: { errors, isSubmitting, isValid },
  } = useForm<typeof defaultValues>({
    mode: "onChange",
    defaultValues,
  });
  const customer = watch("customer");
  const field = watch("field");
  const cajas = watch("cajas");
  const peso_caja = watch("peso_caja");

  const getCustomers = async () => {
    const data = await CustomersService.list();
    setCustomers(data.filter( (d: any) => d.status ));
  };

  const getFields = async (field: string) => {
    const data = await CustomersService.fields(field);
    // Solo huertas activas; se conserva la ya asignada al editar un registro
    setFields(data.filter((d: any) => d.status || d._id === getValues("field")));
  };

  const submit = (data: typeof defaultValues) => {
    onChange(data);
    setShow();
  }

  useEffect(() => {
    getCustomers();
  }, []);

  useEffect(() => {
    setValue("kg_totales", `${UtilsService.round(+cajas * +peso_caja)}`);
  }, [cajas, peso_caja]);

  useEffect(() => {
    const exists = fields.find((row: any) => row._id === field)
    if(!exists) {
      setValue("field", '');
    } else {
      setValue("field", exists._id);
    }
  }, [fields]);

  useEffect(() => {
    setValue("customer", "");
  }, [customers]);

  useEffect(() => {
    if (customer) {
      getFields(customer);
    }
    const find = customers.find(c => c._id === customer); 
    setValue('customer_name', find ? find.name : '');
  }, [customer]);
  
  useEffect(() => {
    const find = fields.find(c => c._id === field); 
    setValue('field_name', find ? find.name : '');
  }, [field]);
  
  useEffect(() => {
    if(!show) {
      reset(defaultValues);
      return;
    }

    if(show && data) {
      reset(data);
      setFields([{
        _id: data.field,
        name: data.field_name
      }]);
    }

  }, [show]);

  return (
    <Modal show={show}>
      <div className="modal-header">
        <h3 className="modal-title">Agregar registro por productor</h3>
        <div
          className="btn btn-icon btn-sm btn-active-light-primary ms-2"
          onClick={setShow}
        >
          <i className="ki-duotone ki-cross fs-1">
            <span className="path1" />
            <span className="path2" />
          </i>
        </div>
      </div>
      <div className="modal-body">
        <div className="mb-5">
          <SelectComponent
            label="Productor *"
            data={customers.map((row) => ({ value: row._id, text: row.name }))}
            {...register("customer", { required: true })}
            errors={errors.customer}
          />
        </div>
        <div className="mb-5">
          <SelectComponent
            label="Huerta *"
            data={fields.map((row) => ({ value: row._id, text: row.name }))}
            {...register("field", { required: true })}
            errors={errors.field}
          />
        </div>
        <div className="mb-5">
          <InputComponent
            label="Cajas *"
            {...register("cajas", {
              required: true,
              pattern: {
                value: /^[0-9]*$/,
                message: "Solo se permiten números",
              },
            })}
            errors={errors.cajas}
          />
        </div>

        <div className="mb-5">
          <InputComponent
            label="Peso por caja *"
            {...register("peso_caja", {
              required: true,
              pattern: {
                value: /^\d+(\.\d{1,2})?$/,
                message: "Solo se permiten números y un máximo de dos decimales",
              },
            })}
            errors={errors.peso_caja}
          />
        </div>

        <div className="alert bg-light-warning border border-warning border-dashed d-flex flex-column flex-sm-row w-100 p-5 ">
          <i className="fa-solid fa-circle-exclamation fs-2hx text-warning me-4 mb-5 mb-sm-0"></i>
          <div className="d-flex flex-column">
            <h5 className="mb-1">Atención</h5>
            <span>
              El campo "Kg totales" es un campo calculado, si deseas puedes
              modificarlo pero esto puede causar una diferencia en los kg
              totales
            </span>
          </div>
        </div>

        <div className="mb-5">
          <InputComponent 
            label="Kg totales *"
            {...register("kg_totales", {
              required: true,
              pattern: {
                value: /^\d+(\.\d{1,2})?$/,
                message: "Solo se permiten números y un máximo de dos decimales",
              },
            })}
            errors={errors.kg_totales}
          />
        </div>
      </div>
      <div className="modal-footer">
        <button className="btn btn-light" type="button" onClick={setShow}>
          Cancelar
        </button>
        <Button
          className="btn btn-primary"
          disabled={!isValid}
          isLoading={isSubmitting}
          onClick={handleSubmit(submit)}
        >
          Guardar
        </Button>
      </div>
    </Modal>
  );
}

export default CustomerForm;
